import { zdarKidsCustomCiphers } from '../zdarKidsGameCustomCiphers';
import audio from '../../../../assets/audio/kids-tracks/Text4.mp3';

export const step5underTheStairs = {
    id: 5,
    title: 'Pod schody',
    taskText: `
        <p>
            Jéé, tamhle vidím dalšího ducha. Tentokrát vypadá jako nějaký princ z pohádky. 
            Má takový ten divný tenký meč a psa. Tak třeba on bude vědět něco víc. 
        </p>
        <p>
            Zdravíme princi, nevíte náhodou, proč se tady tomu místu říká Zelená hora? 
            Jen jsem to dořekl a hned na mě spustil, že není žádný princ, ale mušketýr a že bychom to měli poznat.
            Když on byl naživu, tak se to tu jmenovalo Temný les. Sice slyšel od kolemjdoucích, že se to už tady 
            tak nejmenuje, ale netuší proč. Proč se to tu asi jmenovalo Temný les? Vždyť tu nejsou skoro žádné stromy.
        </p>
        <p>
            Dřív to tu byl prý samý strom, dokonce jich tu bylo tolik, že sem nesvítilo skoro žádné slunce. 
            Proto temný. Zajímavé, co se tu asi stalo? Kam všechny zmizely?
        </p>
        <p>
           Tak moc děkujeme za pomoc, můžeme pro tebe něco udělat? Mušketýr říká, že slýchá od dětí o spoustě 
           pohádkových postav, ale neví, jak vypadají. Pomůžeš mu? Já taky na pohádky moc nekoukám, nemám televizi. 
        </p>
    `,
    cipher: {
        label: 'Úkol',
        custom: zdarKidsCustomCiphers.understairs,
    },
    continueButtonText: 'Pokračovat',
    audio: audio,
    points: true,
    hints: [
        {
            html: `
                <div class="task-text" style="width: 100%">
                    <span>Správné odpovědi:</span>
                    <ul>
                        <li>Burák</li>
                        <li>Červená karkulka</li>
                        <li>Shrek</li>
                        <li>Šmoulinka</li>
                        <li>Včelka Mája</li>
                        <li>Víla Amálka</li>
                    </ul>
                </div>
            `,
        },
    ],
};
